module.exports = __webpack_public_path__ + "assets/img/9bda85c2cb5d156baf86cba8624ae298.png";